
import { useI18n } from "vue-i18n";
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import * as Cashier from "@/api/cashier";
import { Dialog, Toast } from "vant";
import { baseURL } from "@/api/index";

export default defineComponent({
  name: "landing",
  setup() {
    const { t, locale } = useI18n();
    const route = useRoute();
    let { id } = route.query;

    const error = ref(false);

    const getOrderInfo = async () => {
      const res = await Cashier.GetPayInOrderInfo();
      if (res?.code === 200) {
        console.log(res?.data);
        // 关闭
        if ([6].includes(res?.data?.orderStatus)) {
          error.value = true;
          return;
        }

        //  失败、取消
        if ([3, 4].includes(res?.data?.orderStatus)) {
          if (res?.data?.cancelUrl) {
            if (window.location.href !== res?.data?.cancelUrl) {
              window.location.href = res?.data?.cancelUrl;
            }
          }
          return;
        }

        // 成功
        if (res?.data?.orderStatus == 2) {
          setTimeout(() => {
            if (res?.data?.redirectUrl) {
              if (window.location.href !== res?.data?.redirectUrl) {
                window.location.href = res?.data?.redirectUrl;
              }
            }
          }, 2000);
          return;
        }
      }

      setTimeout(() => {
        getOrderInfo();
      }, 3000);
    };

    onMounted(async () => {
      getOrderInfo();
    });

    return {
      error
    };
  }
});
